import { render, staticRenderFns } from "./Fintech.vue?vue&type=template&id=43f0bbb5&scoped=true&"
import script from "./Fintech.vue?vue&type=script&lang=js&"
export * from "./Fintech.vue?vue&type=script&lang=js&"
import style0 from "./Fintech.vue?vue&type=style&index=0&id=43f0bbb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0bbb5",
  null
  
)

export default component.exports